import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';
import {
  GovermentIdReducerAction,
  GovermentIdReducerCases,
  GovermentIdReducerState,
} from '../types';
import {
  filterValidDocuments,
  getEmptyDocumentsState,
  getMultipleDocumentsState,
  getSingleDocumentState,
} from '../utils';

const CASES = {
  [GovermentIdReducerCases.SET_DOCUMENTS]: (
    action: GovermentIdReducerAction
  ): GovermentIdReducerState => {
    const documentsToSave = filterValidDocuments(
      action.payload as IOnboardingDocuments[]
    );

    switch (documentsToSave.length) {
      case 0:
        return getEmptyDocumentsState();
      case 1:
        return getSingleDocumentState(documentsToSave[0]);
      default:
        return getMultipleDocumentsState(documentsToSave);
    }
  },

  [GovermentIdReducerCases.SET_FIRST_DOCUMENT]: (
    state: GovermentIdReducerState,
    action: GovermentIdReducerAction
  ): GovermentIdReducerState => ({
    ...state,
    documentOne: (action.payload as IOnboardingDocuments[])[0],
  }),

  [GovermentIdReducerCases.SET_SECOND_DOCUMENT]: (
    state: GovermentIdReducerState,
    action: GovermentIdReducerAction
  ): GovermentIdReducerState => ({
    ...state,
    documentTwo: (action.payload as IOnboardingDocuments[])[0],
  }),

  [GovermentIdReducerCases.DELETE_DOCUMENTS]: (
    state: GovermentIdReducerState,
    action: GovermentIdReducerAction
  ): GovermentIdReducerState => {
    if (action.payload === 'first') {
      return {
        documentOne: null,
        documentTwo: state.documentTwo,
      };
    }

    if (action.payload === 'second') {
      return {
        documentOne: state.documentOne,
        documentTwo: null,
      };
    }

    return state;
  },
};

export default CASES;
